import { gql } from '@apollo/client'

export const createOrderDocumentLinkQuery = gql`
  mutation createOrderDocumentLink($input: CreateOrderDocumentLinkArgs!) {
    createOrderDocumentLink(input: $input) {
      token
      expiresAt
    }
  }
`
